import { Loader2 } from "@/components/icons"

export function AttachmentPreview({
  src,
  alt,
  isLoading,
  hasError,
  errorText,
  onFullscreen,
}: {
  src: string | null
  alt: string
  isLoading: boolean
  hasError: boolean
  errorText: string
  onFullscreen: () => void
}) {
  if (isLoading) {
    return (
      <div className="border-border flex h-32 items-center justify-center rounded-md border">
        <Loader2
          aria-label="Loading attachment"
          className="text-muted-foreground size-5 animate-spin"
        />
      </div>
    )
  }
  if (hasError || !src) {
    return (
      <div className="border-border text-destructive flex h-32 items-center justify-center rounded-md border px-4 text-center text-xs">
        {errorText}
      </div>
    )
  }
  return (
    <button
      className="group border-border hover:border-primary relative block w-full overflow-hidden rounded-md border"
      type="button"
      onClick={onFullscreen}
    >
      <img alt={alt} className="max-h-64 w-full object-contain" src={src} />
      <span className="absolute right-2 bottom-2 rounded bg-black/60 px-2 py-0.5 text-[10px] font-medium text-white opacity-0 transition-opacity group-hover:opacity-100">
        Click to enlarge
      </span>
    </button>
  )
}
